import React from "react";
import SysWorkflow from "../pages/sys-workflow";
import SysTodo from "../pages/sys-todo";
import KeepAlive from "react-activation";
import ProductQr from "../pages/product-qr";
import NewsClassification from "../pages/news/classification";
import DocumentsClassification from "../pages/documents/classification";
import Documents from "../pages/documents";
import News from "../pages/news";
import ExchangeRate from "../pages/exchange-rate";
import CountryMapping from "../pages/country-mapping";
import Covering from "../pages/covering";
import productOutside from "../pages/product-outside";
import OrderList from "../pages/order-list";
import brandMarket from "../pages/brand-market";
import Country from "../pages/country";
import DesignerCommission from "../pages/designer-commission";

const SysUser = React.lazy(() => import('../pages/sys-user'))
const SysRole = React.lazy(() => import('../pages/sys-role'))
const SysResource = React.lazy(() => import('../pages/sys-resource'))
const SysSite = React.lazy(() => import('../pages/sys-site/index'))

const QuotationAll = React.lazy(() => import('../pages/quotation-all/index'))
const QuotationProgress = React.lazy(() => import('../pages/quotation-progress/index'))
const QuotationResult = React.lazy(() => import('../pages/quotation-result/index'))
const ProductDisplay = React.lazy(() => import('../pages/product-display'))
const ProductSheet = React.lazy(() => import('../pages/product-display/productSheet'))
const CustomerQuotation = React.lazy(() => import('../pages/customer-quotation/index'))
const CustomerQuotationDetail = React.lazy(() => import('../pages/customer-quotation/detail'))
const Customer = React.lazy(() => import('../pages/customer/index'))
const Pillow = React.lazy(() => import('../pages/pillow/index'))
const LoadsGroup = React.lazy(() => import('../pages/loads-group/index'))
const ItemMargin = React.lazy(() => import('../pages/item-margin/index'))
const Product = React.lazy(() => import('../pages/product/index'))
const Freight = React.lazy(() => import('../pages/freight/index'))
const CustomerFeedback = React.lazy(() => import('../pages/customer-feedback/index'))
const CustomerFeedbackRecord = React.lazy(() => import('../pages/customer-feedback/record'))
const QuotationParameters = React.lazy(() => import('../pages/quotation-parameters/index'))


const routes: Routes = {
    '/quotation/progress': {
        render: () => (<KeepAlive><QuotationProgress/></KeepAlive>)
    },
    '/quotation/all': {
        render: () => (<KeepAlive><QuotationAll/></KeepAlive>)
    },
    '/quotation/result': {
        render: () => (<KeepAlive><QuotationResult/></KeepAlive>)
    },
    '/product/display/:quotationId/:type': {
        component: ProductSheet
    },
    '/product/display': {
        render: () => (<KeepAlive><ProductDisplay/></KeepAlive>)
    },
    '/todo': {
        component: SysTodo
    },
    '/sys/user': {
        component: SysUser
    },
    '/sys/role': {
        component: SysRole
    },
    '/sys/resource': {
        component: SysResource
    },
    '/sys/site': {
        component: SysSite
    },
    '/sys/workflow': {
        component: SysWorkflow
    },
    '/sys/news': {
        component: NewsClassification
    },
    '/sys/documents': {
        component: DocumentsClassification
    },
    '/customer/feedback/:feedbackId': {
        component: CustomerFeedbackRecord
    },
    '/customer/feedback': {
        render: () => (<KeepAlive name={'/customer/feedback'}><CustomerFeedback/></KeepAlive>)
    },
    '/customer/quotation/:sheetId': {
        component: CustomerQuotationDetail
    },
    '/customer/quotation': {
        render: () => (<KeepAlive><CustomerQuotation/></KeepAlive>)
    },
    '/basic/customer': {
        component: Customer
    },
    '/basic/pillow': {
        component: Pillow
    },
    '/basic/loads/group': {
        component: LoadsGroup
    },
    '/basic/product': {
        component: Product
    },
    '/basic/freight': {
        component: Freight
    },
    '/basic/item/margin': {
        component: ItemMargin
    },
    '/basic/quotation/parameters': {
        component: QuotationParameters
    },
    '/basic/qr': {
        component: ProductQr
    },
    '/basic/documents': {
        component: Documents
    },
    '/basic/news': {
        component: News
    },
    '/basic/exchange/rate': {
        component: ExchangeRate
    },
    '/basic/country/mapping': {
        component: CountryMapping
    },
    '/basic/covering': {
        component: Covering
    },
    '/basic/brand/market': {
        component: brandMarket
    },
    '/basic/outside/product': {
        component: productOutside
    },
    '/sys/country': {
        component: Country
    },
    '/sys/designer/commission': {
        component: DesignerCommission
    },
    '/order': {
        component: OrderList
    },
}

export default routes
